/** Which camera family counts for template selection. A focused family that is absent falls back to the other. */
export enum LiveContextFocusMode {
  ROOM = 'room',
  REMOTE = 'remote',
  BOTH = 'both',
}
